import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getPages, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getPages';

export type TransactionItemType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface PagesListType {
    language: string;
}

export const getPageList = {
    browser: {
        params: (params: PagesListType): ParamsFetchType<PagesListType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get-pages-list',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get-pages-list',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PagesListType>): Promise<GenerateUrlApiType> => {
        const resp = await openapi_website_cms_getPages(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            language: params.req.body.language
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
